export default "__VITE_ASSET__Bte39N1g__"